import { motion } from 'framer-motion'
import clsx from 'clsx'
import { useTenant } from '@/tenant/TenantProvider'
import { useViewStore } from '@/state/useViewStore'

export function SlideProgressDots() {
  const tenant = useTenant()
  const slides = tenant.slides.enabled
  const current = useViewStore((s) => s.slideIndex) % slides.length
  return (
    <div className="flex items-center gap-1.5" aria-label="Slide progress">
      {slides.map((id, i) => {
        const active = i === current
        return (
          <motion.span
            key={id}
            layout
            className={clsx(
              'h-1.5 rounded-full transition-all duration-300',
              active ? 'bg-brand-primary' : 'bg-border-strong/60',
            )}
            style={{ width: active ? '2rem' : '0.375rem' }}
          />
        )
      })}
    </div>
  )
}
